import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {$accountFactory} from "../../../account/$account.factory";
import {SiteContextService} from "../../../commons/services/site-context.service";

export class OmsValidationTableRowController implements IController {

  order: any;
  orderId: string;
  onToggle: Function;
  onRemove: Function;
  onEdit: Function;

  private entity: any;
  private tasks: any;
  private programNamesMap: any;
  private accountName = undefined;

  public locationTypes: typeof LocationType = LocationType;

  /* @ngInject */
  constructor(private $account: $accountFactory, private siteContextService: SiteContextService) {
    this.programNamesMap = _.get(siteContextService.getSiteInfo(), 'programs', {});
  }

  $onInit() {
    this.entity = this.order.entity;
    this.tasks = _.chain(this.entity.fulfillmentLines)
      .map((line) => {
        var tasks = [];

        if (line.pickupTask) {
          const pickupRef = angular.copy(line.pickupTask);
          pickupRef.packageList = line.packageList;
          pickupRef.purpose = 'Pickup'; // TODO server fix needed!
          tasks.push(pickupRef);
        }
        if (line.destinationTask) {
          const destinationRef = angular.copy(line.destinationTask);
          destinationRef.packageList = line.packageList;
          if (!destinationRef.purpose) {
            destinationRef.purpose = 'Dropoff'; // TODO server fix needed!
          }
          tasks.push(destinationRef);
        }

        return tasks;
      })
      .flattenDeep()
      .value();

    if (this.entity.accountId) {
      this.$account(this.entity.accountId).$asyncValue().then((account) => {
        this.accountName = account.name;
      })
    }
  }

  $onChanges(changes) {
    if (changes.orderId && !changes.orderId.isFirstChange()) {
      this.$onInit();
    }
  }

  getErrorDescriptions() {
    return _.map(this.order, 'mappingErrors.description');
  }
}

angular
.module('bringoz.admin.oms')
.component('omsValidationTableRow', {
  require: {
    omsValidationTableCtrl: '^omsValidationTable'
  },
  bindings: {
    order: '<',
    orderId: '<',
    onToggle: '&',
    onRemove: '&',
    onEdit: '&'
  },
  template: require('./oms-validation-table-row.html').default,
  controller: OmsValidationTableRowController
});
